import React, { useRef } from "react";

import styled from "styled-components";

import Button from "components/atoms/Button";
import Textarea from "components/atoms/Textarea";
import Text from "components/atoms/text/Text";

import { InputWrap, IntroDescription, PanelCard, PlanBox, StatusRow } from "components/organisms/report/styled";

const StatusRowText = styled(Text).attrs({
    variant: "body-md-400",
})``;

export default function PlanningStepSection({
    planningState,
    editablePlanText,
    onEditablePlanTextChange,
    onConfirmPlanning,
    onGoBackRequest,
}) {
    const planTextareaRef = useRef(null);

    const hasPlanText = !!editablePlanText.trim();

    return (
        <PanelCard>
            <StatusRow>
                <StatusRowText>계획 단계</StatusRowText>
            </StatusRow>

            <IntroDescription>에이전트의 연구 계획을 확인하고 수정할 수 있습니다.</IntroDescription>

            {planningState.streaming && !!planningState.streamBuffer && <PlanBox>{planningState.streamBuffer}</PlanBox>}

            {hasPlanText && (
                <>
                    <Textarea
                        ref={planTextareaRef}
                        placeholder="연구 계획을 입력하세요."
                        value={editablePlanText}
                        onChange={(e) => onEditablePlanTextChange(e.target.value)}
                        saveAct={(e) => {}}
                        disabled={planningState.streaming}
                    />
                    <InputWrap>
                        <Button
                            onlyText
                            width={"140px"}
                            height={"44px"}
                            size={"small"}
                            bgColor={"var(--color-Button1)"}
                            hoverBgColor={"var(--color-ButtonHover1)"}
                            fontColor={"var(--color-White)"}
                            buttonText={"분석 시작"}
                            onClick={onConfirmPlanning}
                            disabled={planningState.streaming || !hasPlanText || !editablePlanText.trim()}
                        />
                        <Button
                            onlyText
                            width={"140px"}
                            height={"44px"}
                            size={"small"}
                            bgColor={"var(--color-Button3)"}
                            hoverBgColor={"var(--color-ButtonHover3)"}
                            fontColor={"var(--color-White)"}
                            buttonText={"이전 단계"}
                            onClick={onGoBackRequest}
                        />
                    </InputWrap>
                </>
            )}
        </PanelCard>
    );
}
